import { Class } from './Class';

type Student = {
  id?: number;
  studentNumber: string;
  name: string;
  grade: string;
  classes: Class[];
  bonusPoints: number;
  phone?: string | null;
  messageRecipient?: string | null;
  messagePhone?: string | null;
};

const defaultStudent: Student = {
  studentNumber: "",
  name: "",
  grade: "",
  classes: [],
  bonusPoints: 0,
  phone: "",
  messageRecipient: "",
  messagePhone: "",
};

export { type Student, defaultStudent };